// Modules
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setInfoCust, setLoggedCust } from 'Modules/authority';

// CSS
import '_Asset/css/User/Page/login.css'

// API
import { CmLoginApi, CmRePassApi, CmSessionApi, MemSessionApi } from '_Route/Api';


const Login = () => {

  // Use Hooks
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [info, setInfo] = useState({ // 로그인 Input 정보
    cust_email: '',
    cust_pass: '',
  })
  const { cust_email, cust_pass } = info;


  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }


  /*========================================================================
  * 고객 로그인 Function
  ========================================================================*/
  // Session ID 발급
  const getSessionID = (userUID) => {
    axios({
      url: CmSessionApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': userUID,
      }
    })
    .then(res => {
      // console.log(res, "GET Customer Session ID Success!")
      const result = res.data.result;
      localStorage.setItem('custSessionID', result[result.length - 1].session_id)
      dispatch(setLoggedCust(true))
    })
    .catch(err => {
      console.error(err, "GET Customer Session ID Error...")
    })
  }

  // 고객 로그인
  const login = () => {
    if (cust_email === '') {
      alert("이메일 아이디를 입력해주세요.")
    }
    else if (cust_pass === '') {
      alert("비밀번호를 입력해주세요.")
    } else {
      axios({
        url: CmLoginApi,
        method: 'POST',
        data: info
      })
      .then(res => {
        // console.log(res,"Customer Login Success!")
        const r = res.data;
        if(r.loggedIn){
          dispatch(setInfoCust({ // 로그인된 고객 정보 설정
            dPcorp: r.custCorp,
            dPid: r.custId,
            dPname: r.custName,
            dPuuid: r.custUuid,
            dPchangePass: r.custChangePass,
          }));
          getSessionID(r.custUuid)
          navigate('/')
        }
      })
      .catch(err => {
        console.error(err, "Login ERROR...");
        alert(err.response.data.message);
      })
    }
  }


  return (
    <>
      <div className="login">
        <div className="inner">
          <div className="loginTit">
            <h2>Login</h2>
          </div>
          
          <fieldset>
            <legend>Login Form</legend>

            <div className="fieldGroup">
              <div className="field">
                <div className="inputIco">
                  <input type="email" className="input lg line i_lt" name="cust_email" onChange={(e) => onChange(e)} placeholder="E-mail ID" autoFocus={true} />
                  <img src={require('_Asset/img/login/curved-message.svg').default} alt="Email" />
                </div>
              </div>

              <div className="field">
                <div className="inputIco">
                  <input type="password" className="input lg line i_lt" name="cust_pass" onChange={(e) => onChange(e)} placeholder="Password" maxLength="20" onKeyUp={(e) => e.key === 'Enter' && login()} />
                  <img src={require('_Asset/img/login/curved-lock.svg').default} alt="Password" />
                </div> 
              </div>

              {/* <button type="button" className="fieldTxt right" onClick={() => setPopUpState(true)}>Forgot Password?</button> */}
            </div>
          </fieldset>

          <div className="btnArea full">
            <button type="button" className='btn sfrtBlue md round_10' onClick={login}>LOGIN</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login